import {PureComponent} from 'react'
import {Route, Switch} from 'react-router-dom'
import React from 'react'
import TaxesTable from './container/TaxesTable'
import TaxForm from './container/TaxForm'
import {TaxCategory} from './Model'

export default class Index extends PureComponent {
  render() {
    const taxCategories = Object.keys(TaxCategory).map(
      (key, object) => object[key]
    )
    return (
      <Switch>
        <Route exact path="/taxes" component={TaxesTable} />

        <Route exact path="/taxes/create" component={TaxForm} />

        <Route
          exact
          path="/taxes/:id"
          component={props => <TaxForm {...props} />}
        />
      </Switch>
    )
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/modules/Taxes/index.tsx